document.addEventListener('DOMContentLoaded', function () {
  const announcementBar = document.querySelector('.announcement-bar');
  const body = document.querySelector('body');
  const ctaOrderNow = document.querySelector('.cta-order-now');

  if (!announcementBar) {
      body.classList.add('margin-condition');
  }

  const menu = document.querySelectorAll('.container-menu .menu');
  const header = document.querySelector('.new-header');

  function handleHeaderColor() {
      if (window.scrollY > 0) {
          header.classList.add('white');
      } else {
          header.classList.remove('white');
      }
  }

  window.addEventListener('scroll', handleHeaderColor);
  handleHeaderColor();

  menu.forEach(function (element) {
      element.addEventListener('mouseover', function () {
          header.classList.remove('active');
          menu.forEach(function (element) {
              element.classList.remove('active');
          });
          header.querySelectorAll('.container-sub-menu').forEach(function (element) {
              element.classList.remove('active');
              element.style.height = '0';
          });

          if (element.getAttribute('data-menu') !== null) {
              let subMenu = document.querySelector(`#${element.getAttribute('data-menu')}`);
              if(subMenu) {
                if (subMenu.offsetHeight === 0) {
                  subMenu.style.height = `${subMenu.scrollHeight + 62}px`;
              }
              element.classList.add('active');
              header.classList.add('active');
              subMenu.classList.add('active');
              }
          } else {
              header.classList.remove('active');
              element.classList.remove('active');
              menu.forEach(function (element) {
                  element.classList.remove('active');
              });
              header.querySelectorAll('.container-sub-menu').forEach(function (element) {
                  element.style.height = '0';
              });
          }
      });
  });

  header.addEventListener('mouseleave', function () {
      header.classList.remove('active');
      menu.forEach(function (element) {
          element.classList.remove('active');
      });
      header.querySelectorAll('.container-sub-menu').forEach(function (element) {
          element.classList.remove('active');
          element.style.height = '0';
      });
  });

  document.querySelector('.container-icon-burguer').addEventListener('click', function () {
      document.querySelector('.container-menu-top').classList.add('active');
  });

  document.querySelector('.event-close').addEventListener('click', function () {
      document.querySelector('.container-menu-top').classList.remove('active');
  });

  document.querySelectorAll('.menu-mobile').forEach((element) => {
      element.addEventListener('click', function () {
          let submenu = this.querySelector('.container-sub-menu-mobile');
          let height = submenu.scrollHeight;

          if (this.classList.contains('active')) {
              this.classList.remove('active');
              submenu.style.height = '0';
          } else {
              this.classList.add('active');
              submenu.style.height = `${height}px`;
          }
      });
  });


  setTimeout(function () {
    if(ctaOrderNow) {
        ctaOrderNow.classList.add('collapsed');
    }
}, 1000);

if(ctaOrderNow) {
    ctaOrderNow.addEventListener('click', function () {
        ctaOrderNow.classList.toggle('collapsed');
    });
}



});
